import { FC, LabelHTMLAttributes, ReactNode, createElement } from 'react';
import styles from './styles.module.css';

type Props = {
  inputs?: ReactNode;
  optional?: boolean;
  /** 指定した HTML 要素でラップする。未指定の場合は label */
  wrapBy?: 'div' | 'label';
} & Omit<LabelHTMLAttributes<HTMLLabelElement>, 'className' | 'style'>;

const Label: FC<Props> = ({
  inputs,
  optional = false,
  wrapBy = 'label',
  children,
  ...props
}) => {
  return createElement(
    wrapBy,
    { ...props, className: styles.label },

    <div className={styles['label-text']}>
      <span>{children}</span>
      {optional && <span className={styles.optional}>任意</span>}
    </div>,
    inputs
  );
};
export default Label;
